import { animate, animateChild, query, style, transition, trigger } from '@angular/animations';

export const slideUpAnimation = trigger('slideUp', [
    transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('400ms ease-out', style({ transform: 'translateY(0)', opacity: 1 })),

        // Busca al hijo con la animación y le ordena ejecutarse
        query('@reboundIn', [
            animateChild()
        ], { optional: true })
    ]),
    transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateY(100%)', opacity: 0 }))
    ])
]);